export const name = 're-loyalty-achievement-rewards'

// custom setup

// generic setup
import props from './props'

export {props}

import ComponentMixin from '../../../../../../mixins/components/complex'
import ProfileMixin from '../../../../../../mixins/profile'
import LoyaltyMixin from '../../../../../../mixins/profile/loyalty'
import LoyaltyComponentBaseMixin from '../../../../../../mixins/profile/loyalty/types/base'
import ResponsiveMixin from '../../../../../../mixins/responsive'

export const mixins = [
  ComponentMixin,
  ProfileMixin,
  LoyaltyMixin,
  LoyaltyComponentBaseMixin,
  ResponsiveMixin
]

export const EventBus = window.VueEventBus

// data
const propDefs = props
export const data = {
  propDefs,
  type: 'achievements',
  errorMessage: ''
}

export default {
  name,
  mixins,
  props,
  data,
  EventBus,
}
